import RoundedButtonSecondary from '../rounded-button-secondary/RoundedButtonSecondary';
import styles from './verify-with-bankid-buttons.module.less';

const VerifyWithBankIdButtons = ({ handleBankIdVerification }) => (
    <div className={styles.buttons}>
        <RoundedButtonSecondary onClick={(e) => handleBankIdVerification(e)}>Bekreft med BankID</RoundedButtonSecondary>
    </div>
);
export default VerifyWithBankIdButtons;
